import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fiverr-brands",
  "use": "fiverr-brands-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fiverr-brands\"><path d=\"M297 137c0 17 13.8 30.8 31 30.8 17 0 30.8-13.8 30.8-30.8 0-17.2-13.8-31-30.8-31-17.2 0-31 13.8-31 31zm-73.5-25.9c-40 0-65.9 23.8-71 48.2-.5 2.9-1 5.8-1 8.7v22.8h-26.9v45.3h26.9v103h-26.9V386h117.1v-46.8h-27.2v-103h81.9v103H270V386h117.3v-46.8h-27.9V190.8h-145v-13.6c0-11.2 10.9-17.9 20.1-17.9H257v-48.2h-33.5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol